<template>
  <div v-if="languageData.labels">
    <v-snackbar v-model="snackbar.visible" :color="snackbar.color" :multi-line="snackbar.mode === 'multi-line'" :timeout="snackbar.timeout" :right="snackbar.corner === 'right'" :top="snackbar.position === 'top'">
      <v-layout align-center pr-4>
        <v-icon class="pr-3" dark large>{{ snackbar.icon }}</v-icon>
        <v-layout column>
          <div>
            <strong v-html="snackbar.title"></strong>
          </div>
          <div v-html="snackbar.text"></div>
        </v-layout>
      </v-layout>
      <v-btn v-if="snackbar.timeout === 0" icon @click="snackbar.visible = false">
        <v-icon>clear</v-icon>
      </v-btn>
    </v-snackbar>
    <v-data-table
        loading-text="Loading... Please wait"
        class="users-table"
        :class="$vuetify.breakpoint.mdAndUp ? 'px-6' : 'px-2'"
        :loading="areInvoicesFetching"
        :headers="headersInvoices"
        :options.sync="pagination"
        :server-items-length="totalItems"
        :items-per-page-options="rowsPerPageItems"
        :footer-props="footerOptions"
        :page.sync="currentPage"
        :search="searchInvoice"
        :items="invoices"
        mobile-breakpoint="0"
    >
      <template v-slot:top>
        <div class="top-section-wrapper pt-10 pb-7">
          <div class="filter-container">
          <v-text-field
              v-if="layout !== 'list'"
              v-model="searchInvoice"
              outlined
              @keyup="filtersInvoices(true)"
              :label="languageData.searchInvoices"
              class="mx-4"
          ></v-text-field>
          <v-select v-if="layout === 'list'"
              :label="languageData.labels.select_project"
              v-model="projectSelected"
              :items="getProjectsToSelect"
              height="55px"
              class="search-input"
              outlined
              hide-details
              item-value="id"
              item-text="name"
              @change="filtersInvoices(false)"
              return-object>
            <template slot='selection' slot-scope='{ item }'>
              {{ item.name }}
            </template>
            <template slot='item' slot-scope='{ item }'>
              {{ item.name }}
            </template>
          </v-select>
        </div>
        <v-select
            :label="languageData.invoiceStatus"
            v-model="invoiceStatus"
            :items="invoiceStatusEnum"
            height="55px"
            class="search-input ml-2"
            outlined
            hide-details
            item-value="value"
            item-text="name"
            @change="filtersInvoices(false)"
            return-object>
          <template slot='selection' slot-scope='{ item }'>
            {{ languageData.invoiceStatuses[item.value]  }}
          </template>
          <template slot='item' slot-scope='{ item }'>
            {{ languageData.invoiceStatuses[item.value]  }}
          </template>
        </v-select>
        <div class="add-button-container">
          <v-btn height="55px" width="100%" class="search-button"  @click="createInvoice()" color="primary" v-if="layout === 'list'">
            <v-icon class="mr-2">mdi-plus</v-icon>
            {{ languageData.btnAddInvoice }}
          </v-btn>
        </div>
      </div>
      <p class="text-h5 invoices-header mb-7">{{ languageData.invoicesHeader }}</p>
      </template>
      <template v-slot:item.invoice_type="{ item }">
        {{ item.date }}
        <br>
        {{ item.number }}
      </template>
      <template v-slot:item.project.name="{ item }">
        {{ item.project.name }}
        <br>
        {{ item.client.name }}
        <br>
      </template>
      <template v-slot:item.totalNet="{ item }">
        {{ item.totalNet.toFixed(2) + '€' }}
      </template>
      <template v-slot:item.actions="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <span v-on="on">
              <v-btn
                  v-bind="attrs"
                  v-on="on"
                  @click="editInvoice(item)"
                  icon>
                <v-icon color="fontDefault">edit</v-icon>
              </v-btn>
            </span>
          </template>
          <span>{{ languageData.labels.edit }}</span>
        </v-tooltip>
        <v-tooltip top v-if="item.type !== invoiceTypeEnum.find(el => el.name === 'CORRECTIVE_INVOICE').value">
          <template v-slot:activator="{ on, attrs }">
            <span v-on="on">
              <v-btn
              v-bind="attrs"
              v-on="on"
              icon
              @click="showModalInvoiceSetPaymentForm(item)"
              >
                <v-icon :color="getPaymentStatusColor(item)">euro_symbol</v-icon>
              </v-btn>
            </span>
          </template>
          <span>{{ languageData.labels.setPayment }} <br> {{ !item.isConfirmed ? languageData.labels.invoiceNotConfirmedTooltip : null }}</span>
        </v-tooltip>
        <v-tooltip top v-if="item.type !== invoiceTypeEnum.find(el => el.name === 'CORRECTIVE_INVOICE').value">
          <template v-slot:activator="{ on, attrs }">
            <span v-on="on">
              <v-btn
              v-bind="attrs"
              v-on="on"
              icon
              @click="showInvoicePaymentsModal(item)"
              >
                <v-icon color="fontDefault">payments</v-icon>
              </v-btn>
            </span>
          </template>
          <span>{{ languageData.labels.showInvoicePayments }} <br> {{ !item.isConfirmed ? languageData.labels.invoiceNotConfirmedTooltip : null }}</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <span v-on="on">
              <v-btn
                  v-bind="attrs"
                  v-on="on"
                  @click="openInvoiceCorrection(item)"
                  :disabled="item.type === invoiceTypeEnum.find(el => el.name === 'CORRECTIVE_INVOICE').value"
                  icon>
                <v-icon color="fontDefault">mdi-file-document-edit</v-icon>
              </v-btn>
            </span>
          </template>
          <span>{{ languageData.invoice.correctInvoice }} <br> {{ !item.isConfirmed ? languageData.labels.invoiceNotConfirmedTooltip : null }}</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <span v-on="on">
              <v-btn
                  v-bind="attrs"
                  v-on="on"
                  @click="downloadInvoice(item)"
                  :disabled="!item.isConfirmed"
                  icon>
                <v-icon color="fontDefault">mdi-file-download</v-icon>
              </v-btn>
            </span>
          </template>
          <span>{{ languageData.labels.download }} <br> {{ !item.isConfirmed ? languageData.labels.invoiceNotConfirmedTooltip : null }}</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <span v-on="on">
              <v-btn
                  v-bind="attrs"
                  v-on="on"
                  @click="openInvoice(item)"
                  :disabled="!item.isConfirmed"
                  icon>
                <v-icon color="fontDefault">mdi-file-eye</v-icon>
              </v-btn>
            </span>
          </template>
          <span>{{ languageData.labels.open }} <br> {{ !item.isConfirmed ? languageData.labels.invoiceNotConfirmedTooltip : null }}</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <span v-on="on">
              <v-btn
                  v-bind="attrs"
                  v-on="on"
                  @click="showInvoicePersons(item)"
                  :disabled="!item.isConfirmed"
                  icon>
                <v-icon color="fontDefault">mdi-email-send</v-icon>
              </v-btn>
            </span>
          </template>
          <span>{{ languageData.labels.choosePersonAndSend }} <br> {{ !item.isConfirmed ? languageData.labels.invoiceNotConfirmedTooltip : null }}</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <span v-on="on">
              <v-btn
                  v-bind="attrs"
                  v-on="on"
                  @click="showEmailForm(item)"
                  :disabled="!item.isConfirmed"
                  icon>
                <v-icon color="fontDefault">mdi-email-edit</v-icon>
              </v-btn>
            </span>
          </template>
          <span>{{ languageData.labels.typeEmail }} <br> {{ !item.isConfirmed ? languageData.labels.invoiceNotConfirmedTooltip : null }}</span>
        </v-tooltip>
        <v-tooltip top v-if="layout === 'list'">
          <template v-slot:activator="{ on, attrs }">
            <span v-on="on">
              <v-btn
                  v-bind="attrs"
                  v-on="on"
                  @click="showDeleteInvoiceModal(item)"
                  icon>
                <v-icon color="fontDefault">delete</v-icon>
              </v-btn>
            </span>
          </template>
          <span>{{ languageData.labels.delete}}</span>
        </v-tooltip>
      </template>
      <template v-slot:item.status="{ item }">
        <div>
          <v-chip
            v-if="item.type !== invoiceTypeEnum.find(el => el.name === 'CORRECTIVE_INVOICE').value"
            outlined
            style="padding: 15px; text-transform: uppercase; font-weight: 500; letter-spacing: 1px"
            :color="getPaymentStatusColor(item)"
            class="mb-1 mt-1"
          >
            {{ languageData.invoiceStatuses[item.paymentStatus]}}
          </v-chip>
          <br v-if="item.type !== invoiceTypeEnum.find(el => el.name === 'CORRECTIVE_INVOICE').value">
          <v-chip
            outlined
            style="padding: 15px; text-transform: uppercase; font-weight: 500; letter-spacing: 1px"
            :color="item.isSent ? 'green' : 'error' "
            class="mb-1 mt-1"
          >
            {{ item.isSent ? languageData.labels.sent : languageData.labels.notSent }}
          </v-chip>
        </div> 
      </template>
    </v-data-table>
    <ModalInfo :hidden-agree-btn="true" :layout="'modalSelectTable'" @clicked="hideInvoiceClientPersonsModal" :show-modal="isShowInvoiceClientPersonsModal">
      <template v-slot:header>
        {{ languageData.labels.sendInvoice + ' ' }} {{ activeInvoice ? activeInvoice : null }}
      </template>
      <template v-slot:body>
        <template>
          <ClientPersonsList :layout="'invoice'" :clientPersons="clientPersons"></ClientPersonsList>
        </template>
        <template>
          <p class="favorite-contacts-header">{{ languageData.favoriteContacts}}</p>
          <FavoriteContactsTable layout="sendEmail" emailType="invoice"></FavoriteContactsTable>
        </template>
      </template>
    </ModalInfo>
    <ModalInfo :hidden-agree-btn="true" :layout="'modalForm'" @clicked="hideSendInvoiceEmailFormModal" :show-modal="isShowInvoiceSendEmailModal">
      <template v-slot:header>
        {{ languageData.labels.sendInvoice + ' '}} {{ activeInvoice ? activeInvoice : null }}
      </template>
      <template v-slot:body>
        <EmailForm></EmailForm>
      </template>
    </ModalInfo>
    <ModalInfo v-if="showInvoiceCorrectionModal" :layout="'modalCreateInvoice'" :hidden-agree-btn="true" @clicked="hideModalCorrectionInvoice" :show-modal="showInvoiceCorrectionModal">
      <template v-slot:body>
        <Invoice @closeInvoiceCorrectionEventFromChild="childInvoiceEvent" :layout="'correction'" :invoiceData="invoiceData" :projectData="project" :modelType="modelType"></Invoice>
      </template>
    </ModalInfo>
    <ModalInfo v-if="layout == 'list' && languageData.modalDelete" @doOperation="deleteInvoice" :isLoadingBtn="false" :idData="modalDeleteData.idData" :typeInfo="modalDeleteData.typeInfo" :headModal="modalDeleteData.head" :btnDisAgreeText="languageData.modalDelete.btnDisAgreeText" :btnAgreeText="languageData.modalDelete.btnAgreeText" :vis-agree-btn="true" :visDisAgreeBtn="true" @clicked="hideModalDelete" :show-modal="isShowDeleteModal" :text-modal="modalDeleteData.textInfo"></ModalInfo>
    <ModalInfo v-if="languageData.modalDelete" @doOperation="deleteInvoice" :isLoadingBtn="false" :idData="modalDeleteData.idData" :typeInfo="modalDeleteData.typeInfo" :headModal="modalDeleteData.head" :btnDisAgreeText="languageData.modalDelete.btnDisAgreeText" :btnAgreeText="languageData.modalDelete.btnAgreeText" :visDisAgreeBtn="true" @clicked="hideModalDelete" :show-modal="isShowDeleteModal" :text-modal="modalDeleteData.textInfo"></ModalInfo>
    <ModalInfo v-if="layout === 'list' && isShowCreateInvoiceModal" :layout="'modalCreateInvoice'" :hidden-agree-btn="true" @clicked="hideModalCreateInvoice" :show-modal="isShowCreateInvoiceModal">
      <template v-slot:body>
        <Invoice modelType="invoice" :projectData="null"></Invoice>
      </template>
    </ModalInfo>
    <ModalInfo v-if="isShowInvoicePaidAtModal" :layout="'modalForm'" @clicked="hideModalInvoicePaidAtForm" :hidden-agree-btn="true" :show-modal="isShowInvoicePaidAtModal">
      <template v-slot:body>
        <InvoicePaidForm  :invoice="invoiceToPaid"></InvoicePaidForm>
      </template>
    </ModalInfo>
    <ModalInfo v-if="isShowInvoicePaymentsModal && activeInvoicePaymentItems && headersInvoicePaymentsList" layout="modalSelectTable" @clicked="hideShowInvoicePaymentsModal" :visDisAgreeBtn="false" :hidden-agree-btn="true" :show-modal="isShowInvoicePaymentsModal">
      <template v-slot:body>
        <InvoicePaymentsTable :invoicePaymentItems="activeInvoicePaymentItems" :invoicePaymentHeaders="headersInvoicePaymentsList"></InvoicePaymentsTable>
      </template>
    </ModalInfo>
    <ModalInfo v-if="showEditInvoiceModal" :layout="'modalCreateInvoice'" :hidden-agree-btn="true" @clicked="hideEditIvoiceModal" :show-modal="showEditInvoiceModal">
      <template v-slot:body>
        <Invoice :layout="'edit'" :projectData="null" modelType="invoice"></Invoice>
      </template>
    </ModalInfo>
    <ModalInfo
        v-if="layout === 'list' && languageData.modalDelete"
        @doOperation="deleteInvoice"
        :isLoadingBtn="false"
        :idData="modalDeleteData.idData"
        :typeInfo="modalDeleteData.typeInfo"
        :headModal="modalDeleteData.head"
        :btnDisAgreeText="languageData.modalDelete.btnDisAgreeText"
        :btnAgreeText="languageData.modalDelete.btnAgreeText"
        :visDisAgreeBtn="true" @clicked="hideModalDelete"
        :show-modal="isShowDeleteModal"
        :text-modal="modalDeleteData.textInfo">
    </ModalInfo>
    <ModalInfo
        v-if="languageData.modalUnpaidInvoice"
        @doOperation="invoiceUnpaidAction"
        :isLoadingBtn="false"
        :typeInfo="'info'"
        :headModal="languageData.modalUnpaidInvoice.head"
        :btnDisAgreeText="languageData.modalUnpaidInvoice.btnDisAgreeText"
        :btnAgreeText="languageData.modalUnpaidInvoice.btnAgreeText"
        :visDisAgreeBtn="true" @clicked="hideModalInvoiceUnpaid"
        :show-modal="isShowInvoiceUnpaidModal"
        :text-modal="languageData.modalUnpaidInvoice.textInfo + invoiceUnpaid.number">
    </ModalInfo>
    <ModalInfo
        v-if="languageData.modalConfirmInvoice && invoiceToConfirmation"
        @doOperation="confirmInvoice"
        :isLoadingBtn="false"
        :typeInfo="'info'"
        :headModal="languageData.modalConfirmInvoice.head"
        :btnDisAgreeText="languageData.modalConfirmInvoice.btnDisAgreeText"
        :btnAgreeText="languageData.modalConfirmInvoice.btnAgreeText"
        :visDisAgreeBtn="true" @clicked="hideConfirmInvoiceModal"
        :show-modal="isShowConfirmInvoiceModal"
        :text-modal="languageData.modalConfirmInvoice.textInfo">
    </ModalInfo>
  </div>

</template>

<script type="text/javascript">
import {mapActions, mapState} from "vuex";
import eventBus from "../../../../event-bus/eventBus";
import downloadFileHelper from "../../../../helpers/downloadFileHelper";
import openFileHelper from "../../../../helpers/openFileHelper";
import ClientPersonsList from "../../../Clients/components/ClientPersonsList/ClientPersonsList";
import ModalInfo from "../../../../components/ModalInfo/ModalInfo";
import EmailForm from "../SendEmailForm/SendEmailForm";
import Invoice from "../Invoice/Invoice";
import invoiceTypeEnum from "../../enums/invoiceTypeEnum";
import invoiceStatusEnum from "../../enums/invoiceStatusEnum";
import InvoicePaidForm from "../InvoicePaid/InvoicePaidForm";
import FavoriteContactsTable from "../../../Company/components/FavoriteContacts/FavoriteContactsTable.vue"
import InvoicePaymentsTable from "../InvoicePayments/InvoicePaymentsTable.vue";

export default {
  name: "Invoices",
  components: {InvoicePaidForm, ClientPersonsList, EmailForm, ModalInfo, Invoice, FavoriteContactsTable, InvoicePaymentsTable },
  props: {
    modelType: String,
    layout: String
  },
  data() {
    return {
      projectSelected: { id: null },
      invoiceTypeEnum: invoiceTypeEnum,
      searchInvoice: null,
      searchTask: null,
      searchDebouceTime: 500,
      currentPage: 1,
      activeInvoice: null,
      showInvoiceCorrectionModal: false,
      invoiceData: {},
      invoiceToPaid: null,
      isShowInvoiceUnpaidModal: false,
      invoiceUnpaid: {},
      footerOptions: {
        'items-per-page-options': [10, 25, 50, 100],
        'disablePagination': false
      },
      invoiceStatus: 0,
      invoiceStatusEnum: invoiceStatusEnum,
      snackbar: {
        color: null,
        icon: null,
        mode: null,
        position: null,
        text: null,
        corner: null,
        timeout: 1000,
        title: null,
        visible: false
      },
      isShowConfirmInvoiceModal: false,
      invoiceToConfirmation: null,
      showEditInvoiceModal: false,
      isShowInvoicePaymentsModal: false,
      activeInvoicePaymentItems: [],
    }
  },
  computed: {
    ...mapState("getHeadersInvoices", {
      headersInvoices: state => state.headersInvoices
    }),
    ...mapState("getInvoiceClientPersons", {
      clientPersons: state => state.clientPersons
    }),
    ...mapState("getInvoices", {
      invoices: state => state.invoices,
      areInvoicesFetching: state => state.areInvoicesFetching,
      totalItems: state => state.pagination.totalItems,
      rowsPerPageItems: state => state.pagination.rowsPerPage,
      sortBy: state => state.pagination.sortBy,
      loadingProjects: state => state.loadingProjects,
    }),
    ...mapState("updateVisibleInvoiceClientPersonsModal", {
      isShowInvoiceClientPersonsModal: state => state.isShowInvoiceClientPersonsModal
    }),
    ...mapState("updateVisibleInvoiceSendEmailModal", {
      isShowInvoiceSendEmailModal: state => state.isShowInvoiceSendEmailModal
    }),
    ...mapState("getProjects", {
      projects: state => state.dataReceive
    }),
    ...mapState("updateVisibleCreateInvoiceModal", {
      isShowCreateInvoiceModal: state => state.isShowCreateInvoiceModal
    }),
    ...mapState("getProject", {
      project: state => state.dataReceive
    }),
    ...mapState("getInvoice", {
      invoice: state => state.dataReceive,
    }),
    ...mapState("deleteInvoice", {
        isShowDeleteModal: state => state.isShowDeleteModal,
        isLoadingDeleteModal: state => state.isLoadingDeleteModal,
        modalDeleteData: state => state.modalDeleteData,
      }),
    ...mapState("updateVisibleInvoicePaidAtModal", {
      isShowInvoicePaidAtModal: state => state.isShowInvoicePaidAtModal
    }),
    ...mapState("getHeadersInvoiceItems", {
      headersInvoiceItems: state => state.headers
    }),
    ...mapState("getHeadersInvoicePaymentsList", {
      headersInvoicePaymentsList: state => state.headersInvoicePaymentsList
    }),
    ...mapState("confirmInvoice", {
      confirmInvoiceFetching: state => state.confirmInvoiceFetching,
    }),
   
    pagination: {
      set: function(value) {
        this.searchInvoices(value);
      },
      get: function() {
        return this.$store.state.getInvoices.pagination;
      }
    },
    getProjectsToSelect: function() {
      let all = [
        {
          name: this.languageData.allInvoices,
          id: null,
          value: null
        }
      ];
      return all.concat(this.projects);
    },
  },
  methods: {
    ...mapActions("getHeadersInvoices", ["getHeadersInvoices"]),
    ...mapActions("getHeadersInvoiceItems", ["getHeadersInvoiceItems"]),
    ...mapActions("getInvoices", ["getInvoices"]),
    ...mapActions("getBase64Invoice", ["getBase64Invoice"]),
    ...mapActions("getInvoiceClientPersons", ["getInvoiceClientPersons"]),
    ...mapActions("updateVisibleInvoiceClientPersonsModal", ["updateVisibleInvoiceClientPersonsModal"]),
    ...mapActions("updateVisibleInvoiceSendEmailModal", ["updateVisibleInvoiceSendEmailModal"]),
    ...mapActions("sendInvoice", ["prepareInvoice"]),
    ...mapActions("getProjects", ["getProjects"]),
    ...mapActions("deleteInvoice", ["deleteInvoiceRequest", "showModalDeleteData", "hideModalDeleteAction"]),
    ...mapActions("updateVisibleCreateInvoiceModal", ["updateVisibleCreateInvoiceModal"]),
    ...mapActions("getInvoice", ["getInvoice"]),
    ...mapActions("getRecipients", ["getRecipients"]),
    ...mapActions("updateVisibleInvoicePaidAtModal", ["updateVisibleInvoicePaidAtModal"]),
    ...mapActions("paymentInvoice", ["invoiceIsUnpaid"]),
    ...mapActions("confirmInvoice", ["confirmInvoiceRequest"]),
    ...mapActions("getHeadersInvoicePaymentsList", ["getHeadersInvoicePaymentsListRequest"]),

    hideShowInvoicePaymentsModal() {
      this.isShowInvoicePaymentsModal = false;
    },

    showInvoicePaymentsModal(invoice) {
      this.activeInvoicePaymentItems = invoice.paymentItems;
      this.isShowInvoicePaymentsModal = true;
    },
    
    getPaymentStatusColor(invoice) {
      return this.invoiceStatusEnum.find(el => el.value === invoice.paymentStatus).color;
    },

    hideInvoiceClientPersonsModal() {
      this.updateVisibleInvoiceClientPersonsModal(false);
      this.updateVisibleCreateInvoiceModal(false);
      if (this.$route.name === 'InvoiceList') {
        this.searchInvoices({});
      }
    },

    hideSendInvoiceEmailFormModal() {
      this.updateVisibleInvoiceSendEmailModal(false);
      this.updateVisibleCreateInvoiceModal(false);
      if (this.$route.name === 'InvoiceList') {
        this.searchInvoices({});
      }
    },

    childInvoiceEvent(eventValue) {
      this.showInvoiceCorrectionModal = eventValue;
    },

    createInvoice: function() {
      eventBus.$emit("createInvoice", this.projectSelected);
      this.updateVisibleCreateInvoiceModal(true);
    },
    hideModalCreateInvoice: function() {
      this.updateVisibleCreateInvoiceModal(false);
    },

    filtersInvoices: function(debounce) {
      if(debounce) {
        clearTimeout(this.searchTask);
        this.searchTask = setTimeout(() => {this.searchInvoices({}, true)}, this.searchDebouceTime);   
      } else {
        this.searchInvoices({}, true);
      }
    
    },
    searchInvoices: function(valueSearch={}, filters=false) {
      valueSearch.filters = filters;
      valueSearch.search = this.searchInvoice;
      valueSearch.modelType = this.modelType;
      valueSearch.status = this.invoiceStatus.value;
      valueSearch.id = (this.layout === 'list') ? this.projectSelected.id : undefined; 
      this.getInvoices({valueSearch});
      if(filters) {
        this.currentPage = 1;
      }
    },
    downloadInvoice(item) {
      let id = item.id;
      let operation = "download";
      this.getBase64Invoice({ creds: { id, operation } });
    },
    hideModalDelete: function() {
      this.hideModalDeleteAction();
    },
    showDeleteInvoiceModal(item) {
        var modalDeleteData = {};
        modalDeleteData.name = item.name;
        modalDeleteData.id = item.id;
        modalDeleteData.number = item.number;
        modalDeleteData.index = this.invoices.indexOf(item);
        modalDeleteData.languageData = this.languageData.modalDelete;
        this.showModalDeleteData(modalDeleteData);
    },
    deleteInvoice(id) {
      this.idInvoiceToDelete = id;
      this.deleteInvoiceRequest(id);
    },
    openInvoice(item) {
      let id = item.id;
      let operation = "open";
      this.getBase64Invoice({ creds: { id, operation } });
    },
    showInvoicePersons(item) {
      let id = item.id
      this.getInvoiceClientPersons({ creds: { id } });
      this.updateVisibleInvoiceClientPersonsModal(true);
      this.prepareInvoice(item);
      this.activeInvoice = item.number;
    },
    showEmailForm(item) {
      this.updateVisibleInvoiceSendEmailModal(true);
      this.activeInvoice = item.number;
      this.prepareInvoice(item);
    },
    openInvoiceCorrection(item) {
      const language = this.getCurrentLanguage;
      if(this.headersInvoiceItems.length === 0) {
        this.getHeadersInvoiceItems({ creds: { language } });
      }
      this.getInvoice({creds: {
          invoiceId: item.id,
          isCorrection: true
        }})
      this.showInvoiceCorrectionModal = true;
    },
    hideModalCorrectionInvoice: function() {
      eventBus.$emit('closeCorrectionInvoice')
      this.showInvoiceCorrectionModal = false;
    },
    getSnackBar: function(title, message, icon, color) {
      this.snackbar = {
        color: color,
        icon: icon,
        mode: "multi-line",
        position: "top",
        corner: 'right',
        title: title,
        text: message,
        visible: true
      };
    },
    hideModalInvoicePaidAtForm() {
      this.updateVisibleInvoicePaidAtModal(false);
    },
    showModalInvoiceSetPaymentForm(item) {
      this.updateVisibleInvoicePaidAtModal(true);
      this.invoiceToPaid = item;
    },
    showModalInvoiceUnpaid(item) {
      this.invoiceUnpaid = item;
      this.isShowInvoiceUnpaidModal = true;
    },
    invoiceUnpaidAction() {
      this.invoiceIsUnpaid({creds: {invoice: this.invoiceUnpaid, paidAt: null}})
    },
    hideModalInvoiceUnpaid() {
      this.isShowInvoiceUnpaidModal = false;
    },
    hideConfirmInvoiceModal() {
      this.isShowConfirmInvoiceModal = false;
    },
    confirmInvoice() {
      this.confirmInvoiceRequest(this.invoiceToConfirmation.id);
    },
    hideEditIvoiceModal() {
      this.showEditInvoiceModal = false;
    },
    editInvoice(item) {
      this.getInvoice({creds: {
          invoiceId: item.id,
      }})
      this.showEditInvoiceModal = true;
    }
  },
  mounted() {
    this.getHeadersInvoicePaymentsListRequest();

    eventBus.$on('confirmInvoiceSuccess', (data) => {
      this.searchInvoices();
      this.getSnackBar(data.message, data.data.textInfo, "check_circle", "success");
    });

    eventBus.$on("setDisablePagination", (value) => {
      this.footerOptions.disablePagination = value;
    });
    eventBus.$on("operationInvoice", (data, operation) => {
      if(operation === "download") {
        downloadFileHelper(data);
      }
      else if(operation === "open") {
        openFileHelper(data)
      }
    });
    let needProjectHeader = this.layout === "list" ? true : false;
    this.getHeadersInvoices({ creds: { language: this.getCurrentLanguage, projectHeader:  needProjectHeader} });
    eventBus.$on("sendInvoiceSuccess", (snackbarData) => {
      this.getSnackBar(snackbarData.title, snackbarData.message, "check_circle", "success");
    });
    eventBus.$on("sendInvoiceFailure", (snackbarData) => {
      this.getSnackBar(snackbarData.title, snackbarData.message, "check_circle", "red");
    });

    eventBus.$on("deleteInvoiceSuccess", (data) => {
      if (data.data.isConfirmed) {
        this.getSnackBar(data.message, data.data.textInfo, "check_circle", "error");
      } else {
        this.getSnackBar(data.message, data.data.textInfo, "check_circle", "success");
        this.searchInvoices({});
      } 
    });
    eventBus.$on("saveInvoiceSuccess", () => {
      if(this.showInvoiceCorrectionModal) {
        this.showInvoiceCorrectionModal = false;
      }
      this.searchInvoices({});
    });
    eventBus.$on("sendInvoiceSuccess", () => {
      if(this.showInvoiceCorrectionModal) {
        this.showInvoiceCorrectionModal = false;
      }
      this.searchInvoices({});
    });
    eventBus.$on("invoicePaidAtSuccess", (snackbarData) => {
      this.searchInvoices({});
      this.updateVisibleInvoicePaidAtModal(false);
      this.getSnackBar(snackbarData.title, snackbarData.message, "check_circle", "success");
    })
    eventBus.$on('hideModalSendInvoice', () => {
      this.searchInvoices({});
    })
    eventBus.$on('hideInvoiceModalEvent', () => {
      this.showEditInvoiceModal = false;
    })
    eventBus.$on("deleteInvoicePaymentItemSuccess", () => {
      this.searchInvoices({});
    });
    eventBus.$on('sendInvoiceSuccess', () => {
      this.updateVisibleInvoiceClientPersonsModal(false);
      this.updateVisibleInvoiceSendEmailModal(false);
    }) 
  },
  beforeDestroy() {
    eventBus.$off('operationInvoice')
    eventBus.$off('invoicePaidAtSuccess')
    eventBus.$off('deleteInvoiceSuccess');
  }
}
</script>

<style src="./Invoices.scss" lang="scss"></style>